<div class="mb-42" style="height: 28px;">
  <h3>{{ 'dashboard.reports.title' | translate | titlecase }}</h3>
</div>
<div style="height: calc(100% - 70px);" id="dashboard-reports">
  <wl-card>
    <div class="mct-flex mct-col mct-justify-between mct-items-stretch"   style="height: 28rem;">
      <div>
        <div *ngFor="let report of searchResults?.Result">
          <div class="f-wb mb-16">
            <a (click)="openReport(report)">{{ report.TabName }}</a>
          </div>
        </div>
      </div>
      <div>
        <wl-paging-controls #pagingControls [pagedResult]="searchResults"
          (pagingEvent)="onPagingEvent($event)"></wl-paging-controls>
        <wl-dashboard-neo-reports-config [myDashboardReports]="searchResults?.Result"
          (myReportsSaved)="loadReports()"></wl-dashboard-neo-reports-config>
      </div>
    </div>
  </wl-card>
</div>
